// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1DWS8","content":"styles_content__qK5_f"};